import { useLocation, Navigate } from 'react-router';

const CheckValidity = ({
  children,
  validation,
}: {
  children: React.ReactNode;
  validation?: string;
}) => {
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user')!)
    : null;

  switch (validation) {
    case 'user': {
      const email = query.get('email');
      return user || email ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    }
    case 'trial': {
      const trial = query.get('trial');
      return trial ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    }
    case 'deleteAccount': {
      const userId = query.get('userId');
      const token = query.get('token');
      return userId && token ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    }
    case 'uid': {
      const uid = query.get('uid');
      return uid ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    }

    default: {
      const userId = query.get('userId');
      const token = query.get('token');
      return userId && token ? (
        children
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    }
  }
};

export default CheckValidity;
